import React, { useMemo } from 'react';
import styled from 'styled-components';
import DOMPurify from 'dompurify';

const SanitizedDiv = styled.div`
	word-wrap: break-word;
	overflow-wrap: break-word;
	white-space: normal;
	max-width: 100%;

	p {
		margin-bottom: 1rem;
	}

	p:last-child {
		margin-bottom: 0;
	}
`;

const DangerousContent = ({ content, color, className }) => {
	const sanitizedContent = useMemo(
		() =>
			DOMPurify.sanitize(content || '')
				.replace(/&nbsp;/g, ' ')
				.replace(/\u00A0/g, ' '),
		[content]
	);

	return (
		<SanitizedDiv
			dangerouslySetInnerHTML={{ __html: sanitizedContent }}
			className={`sanitized__content ${className || ''}`}
			style={{ color: color }}
		/>
	);
};

export default DangerousContent;
